// extracted by mini-css-extract-plugin
export default {"container":"DSIFeatureFlags_container__fPaQ1","list":"DSIFeatureFlags_list__Kpwix"};